import { getPeriodDateRangeValues, periodDateRangeDeserializer } from '@/core/ui';
import { appSessionStorage, createAppAsyncThunk } from '@/warehouse/helpers';
import { getDatesFromStoredValue } from '@/core/ui/StoredPeriodDateRange/helpers';
import { formatDateForApiRequest } from '@/core/utils/datetime';
import { pickingApi } from '@/warehouse/modules/picking/business';
import { pickingTasksDefaultPeriodDateRange } from '@/warehouse/modules/picking/constants';
/**
 * This workflow is needed to initiate **picked** picking tasks request to have `pickedTaskCount` counter defined even
 * if tab's data is not necessary to be loaded, since it is not shown.
 */
const initPickingTasks = createAppAsyncThunk('picking/initPickingTasks', async (_, { dispatch, rejectWithValue, fulfillWithValue }) => {
    const defaultPeriodDateRangeValues = {
        period: pickingTasksDefaultPeriodDateRange,
        ...getPeriodDateRangeValues(pickingTasksDefaultPeriodDateRange),
    };
    const storedPeriod = appSessionStorage.getDeserializedItem('pickingPeriodFilter', defaultPeriodDateRangeValues, {
        deserializer: periodDateRangeDeserializer,
    });
    const rangeValues = getDatesFromStoredValue(storedPeriod);
    try {
        await dispatch(pickingApi.endpoints.getPickingTasks.initiate({
            article: '',
            isPicked: true,
            dateFrom: rangeValues.dateFrom ? formatDateForApiRequest(rangeValues.dateFrom) : '',
            dateTo: rangeValues.dateTo ? formatDateForApiRequest(rangeValues.dateTo) : '',
        })).unwrap();
        return fulfillWithValue({ success: true });
    }
    catch (error) {
        console.error(`In initPickingTasks() -> getPickingTasks() api request error:`, error);
        if (error instanceof Error) {
            return rejectWithValue(`In initPickingTasks() -> getPickingTasks() api request failed with message: ${error.message}`);
        }
        return rejectWithValue('Server unexpected error');
    }
});
export { initPickingTasks };
